/**
 * Este archivo es para definir varios pequeños estilos reutilizables
 *
 * al definirlos como constants acá, evitamos los redraw en los componentes
 */
import { CSSProperties } from 'react';
import { CSSObject } from '@mantine/core';

export const VariosStyles: Record<string, CSSProperties> = {
    marginLeftAuto: { marginLeft: 'auto' },
    monospaced: {
        // fontFeatureSettings: `'tnum'`,
        fontFamily: `'Source Code Pro', monospace`,
        // fontFeatureSettings: `'tnum'`,
        textDecoration: 'none',
        fontSize: 16,
        textAlign: 'right',
    },
    noInteraction: {
        pointerEvents: 'none',
    },
    ulWithoutPadding: { paddingLeft: 0, listStylePosition: 'inside' },
};

VariosStyles.forMoney = {
    ...VariosStyles.monospaced,
    textAlign: 'right',
};

/**
 * Es como el de arriba, pero mantine a veces pide CSSObject
 */
export const CssObjectsVarios: Record<string, CSSObject> = {
    displayNone: {
        display: 'none',
    },
};
